import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next';
import "../Styles/ShareStudyLinkCss.css";
import { CopyIcon } from '@fluentui/react-icons-mdl2';
import { Checkbox, Icon, TextField } from '@fluentui/react';
import themeContext from '../../../../context/theme/ThemeContext';

const ShareStudyLinkPasswordValidateBody = (props) => {
    const [t] = useTranslation();
    const { getThemeColor,getAlterColor ,themeName} = useContext(themeContext);
    
    

    const textFieldStyle = {
      fieldGroup: {
        '&.is-disabled': {
          background: 'transparent !important',
          border:'1px solid rgba(200, 198, 196, 0.3) !important',
          cursor:'not-allowed',
        },
      },
      root:{
        width:'100%',
        borderRadius: '7px',
        '&.is-disabled': {
          backgroundColor: 'transparent !important',
          cursor:'not-allowed',
          border:'none !important'
        },
      },
      field: {
            backgroundColor: 'transparent !important',
            border:'1px solid rgba(200, 198, 196, 0.3) !important'
      },
    }

    const checkBoxStyle = {
        root: {
          paddingLeft: "5px"
        },
        checkbox: {
          borderColor: "#8A8886",
          width: "16px",
          height: "16px"
        },
      };

      const textFieldStyles = {
        root: {
          userSelect: 'none', // Make the text unselectable
        },
      };


      const handleContextMenu = (e) => {
        e.preventDefault(); // Prevent right-click context menu
      };
    
      const handleCopy = (e) => {
        e.preventDefault(); // Prevent Ctrl+C
      };

  return (
    <div className="share-study-container">
                <div className='share-study-content'>
                    <div className='shareStudyPasswordContentContainer'>
                    <div className='content-2' style={{display:'flex'}}>
                        <div className='shareStudy-password-label' style={{marginRight:'10px'}}>
                            <label style={{color: getThemeColor('primary-color')}} className='shareStudy-passwordLabel'>{t("share-study.password")}</label>
                        </div>
                        <TextField
                        className="textArea" 
                        name="password"
                        styles={textFieldStyle}
                        placeholder={t("share-study.placeholder.password")}
                        onChange={props.handleChange}
                        value={props.values.password}
                        errorMessage={props.errors.password || props.authError}
                        />
                    </div>
                    </div>
                </div>
            </div>
  )
}

export default ShareStudyLinkPasswordValidateBody